module.exports = __webpack_public_path__ + "ilya-yakover.efe053682ec97d330ada.jpg";


//////////////////
// WEBPACK FOOTER
// C:/s4in/azim-tav/src/assets/img/ilya-yakover.jpg
// module id = ../../../../../src/assets/img/ilya-yakover.jpg
// module chunks = styles